import React from 'react'
import { NavLink } from 'react-router-dom';
import "./NewButton.scss";

const NewButton = ({text, color, url}) => {
  return (
    <NavLink to={url} className={`new-btn ${color ? color : ""}`} color={color}>
      <span>{text}</span>
    </NavLink>
  )
}

export default NewButton;
